<script>
import {
    Line
} from "vue-chartjs";
//import _ from "lodash";
export default {
    extends: Line,
    data() {
        return {
            date: new Date().getFullYear(),
            data: {
                labels: [
                    "JANV",
                    "FÉVR",
                    "MARS",
                    "AVRI",
                    "MAI ",
                    "JUIN",
                    "JUIL",
                    "AOÛT",
                    "SEPT",
                    "OCTO",
                    "NOVE",
                    "DÉCE"
                ],
                datasets: [{
                    data: new Array(12),
                    label: "Année " + new Date().getFullYear(),
                    borderColor: "#28C76F",
                    fill: false
                }, {
                    data: new Array(12),
                    label: "Année " + (new Date().getFullYear() - 1),
                    borderColor: "#Fe95cd",
                    fill: false
                }, ]
            },
            options: {

            }
        };
    },
    methods: {
        getdata() {
            let d = new Date().getFullYear();

            let localDataN = JSON.parse(JSON.stringify(this.$store.state.article.analytcsdata.listData.filter(el => {
                return el.Date.substring(0, 4) == d
            })));
            let localDataN_1 = JSON.parse(JSON.stringify(this.$store.state.article.analytcsdata.listData.filter(el => {
                return el.Date.substring(0, 4) == (d - 1)
            })));
            let i = 0;

            for (i = 0; i < localDataN.length; i++) {

                this.data.datasets[0].data[Number(localDataN[i].Date.substring(5, 7)) - 1] = localDataN[i].No_of_Return_Orders
            }

            for (i = 0; i < localDataN_1.length; i++) {

                this.data.datasets[1].data[Number(localDataN_1[i].Date.substring(5, 7)) - 1] = localDataN_1[i].No_of_Return_Orders
            }
            this.renderChart(this.data, this.options);
            this.show = true;
        },
        compareMonth(a, b) {
            let months = [
                "JANV",
                "FÉVR",
                "MARS",
                "AVRI",
                "MAI ",
                "JUIN",
                "JUIL",
                "AOÛT",
                "SEPT",
                "OCTO",
                "NOVE",
                "DÉCE"
            ];
            if (a.substring(5, 9) == b.substring(5, 9)) {
                if (
                    months.indexOf(a.substring(0, 4)) < months.indexOf(b.substring(0, 4))
                )
                    return -1;
                else if (
                    months.indexOf(a.substring(0, 4)) > months.indexOf(b.substring(0, 4))
                )
                    return 1;
                else return 0;
            } else if (a.substring(5, 9) < b.substring(5, 9)) return -1;
            else return 1;
        }
    },
    mounted() {
        this.renderChart(this.data, this.options);
    },
    created() {
        if (this.$store.state.article.analytcsdata.listData.length > 0) {
            this.getdata();

        } else

            this.$store.subscribe(mutation => {
                if (mutation.type === "article/UPDATE_ANALTCS_DATA") {
                    this.getdata();

                }
            });
    }
};
</script>
